import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import topLoader from "./slices/loaderSlice";
import authReducer from "./slices/authSlice"; // No .jsx extension needed if using proper config
import accessReducer from "./slices/accessSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth","accessDetails"],
};

const reducers = combineReducers({
  topLoader: topLoader,
  auth: authReducer,
  accessDetails: accessReducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;
